export const environment = {
  "production": false,
  "api": {
    "identity": "",
    "backend": ""
  },
  "appName": "Ground Support Equipments",
  "version": "1.0.0"
};
